import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tagsApi from '@/features/dashboard/tags/api/tagsApi.ts';
import { tagsApiQueryKeys } from '@/features/dashboard/tags/api/tagsApi.queryKeys.ts';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';

/**
 * Removes a tag (by id) from a given target.
 * `onMutated` lets callers (e.g. a table cell) refresh extra queries.
 */
const useUnassignTag = (
  targetType: TaggableType,
  targetId: string,
  options?: { onMutated?: () => void },
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tagId: string) =>
      tagsApi.unassign({ tagId, targetType, targetId }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tagsApiQueryKeys.forTarget(targetType, targetId),
      });
      options?.onMutated?.();
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description: error.message || 'Nie udało się odpiąć tagu.',
      });
    },
  });
};

export default useUnassignTag;
